var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOd2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6766_44531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8332 13.4513V14.3085C9.51049 14.3102 8.23845 13.7987 7.28516 12.8816V17.8381H21.4295C22.1396 17.8381 22.7154 17.2624 22.7154 16.5523V12.2661H7.88057C8.6746 13.0277 9.73275 13.4526 10.8332 13.4513ZM19.7151 15.2664H20.5723V16.1237H19.7151V15.2664ZM18.0006 15.2664H18.8578V16.1237H18.0006V15.2664ZM16.2861 15.2664H17.1433V16.1237H16.2861V15.2664ZM14.5716 15.2664H15.4289V16.1237H14.5716V15.2664Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.40054 8.40869C3.93425 8.41351 3.53619 8.74627 3.44871 9.20419C3.36102 9.66211 3.6086 10.1181 4.03994 10.2946L6.14808 11.1411L5.30361 9.02148C5.15732 8.65105 4.79902 8.40786 4.40054 8.40869Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.318 21.5839C18.5907 21.7145 18.904 21.731 19.1887 21.6297C19.4735 21.5287 19.706 21.3181 19.8349 21.0448L20.9538 18.6956H12.2998L18.318 21.5839Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.28467 7.12277V11.4089H4.51039L3.72054 11.0917C2.94263 10.7836 2.47174 9.9881 2.57596 9.15786C2.68019 8.32762 3.33274 7.67319 4.16256 7.56666C4.99258 7.46013 5.78933 7.92872 6.0997 8.70559L6.42807 9.52976V5.83691H2.57052C1.86041 5.83691 1.28467 6.41266 1.28467 7.12277Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.68155 2.51981C5.40906 2.38921 5.09576 2.37289 4.81113 2.47397C4.52629 2.57527 4.29378 2.78581 4.16465 3.05914L3.25049 4.97975H10.8074L5.68155 2.51981Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.99914 13.4513C4.09956 13.4526 5.15771 13.0277 5.95195 12.2661H1.28467V16.5523C1.28467 17.2624 1.86041 17.8381 2.57052 17.8381H6.42807V12.9905C5.48817 13.8399 4.26594 14.3098 2.99914 14.3085V13.4513Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.427473 12.9619V10.9109L0.111033 11.5762C-0.11667 12.0555 0.0141336 12.6287 0.427473 12.9619Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5728 11.1418V13.1924L23.889 12.5275C24.1169 12.0481 23.9861 11.475 23.5728 11.1418Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4295 5.83691H7.28516V9.82904L7.73261 8.70559C8.04507 7.93333 8.83952 7.46934 9.66557 7.57629C10.4918 7.68344 11.1417 8.33453 11.2471 9.161C11.3524 9.98726 10.887 10.7807 10.1141 11.0917L9.32192 11.4089H22.7154V7.12277C22.7154 6.41266 22.1396 5.83691 21.4295 5.83691ZM15.4289 8.83723H14.5716V7.12277H15.4289V8.83723ZM17.1433 8.83723H16.2861V7.12277H17.1433V8.83723ZM18.8578 8.83723H18.0006V7.12277H18.8578V8.83723ZM20.5723 8.83723H19.7151V7.12277H20.5723V8.83723Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4044 9.38697C10.4076 8.91921 10.0769 8.5155 9.61753 8.42634C9.15815 8.33719 8.70044 8.58812 8.52841 9.02323L7.68457 11.1427L9.7925 10.2944C10.1634 10.1463 10.4059 9.78649 10.4044 9.38697Z",
    fill: "#292929"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6766_44531"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOd2);
export default __webpack_public_path__ + "static/media/od-2.ced0b5801a360b1143b141b2e813e493.svg";
export { ForwardRef as ReactComponent };